export default __webpack_public_path__ + "static/media/check.7b7389b9.gif";